var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin-square-flat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "back",
    width: 512,
    height: 512,
    fill: "#0076b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Linkedin-2",
    "data-name": "Linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.3,207h59.47V398.16H116.3Zm29.75-95a34.45,34.45,0,1,1-34.47,34.45A34.46,34.46,0,0,1,146.05,112",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,207h57v26.14h.81c7.92-15,27.31-30.88,56.21-30.88,60.16,0,71.28,39.59,71.28,91.07V398.16H338.9v-93c0-22.17-.38-50.69-30.87-50.69-30.92,0-35.63,24.16-35.63,49.1v94.55H213Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dd9f249107a1c42d3459b830d8521fab.svg";
export { ForwardRef as ReactComponent };